/** Shared Social defaults — use across all Danzflo platforms. */
export const DEFAULT_PROFILE_IMAGE =
  "https://danzflo.com/social/static/img/default_user.jpg";

export const DEFAULT_BANNER_IMAGE =
  "https://danzflo.com/social/themes/Danzflo/img/danzflo-logo.png";
